export default [
  {
    path:"/calender",
    name:"Calender",
    component: () => import("@/components/layout/Calender"),
    meta: {
      title: "Agendamento"
    }
  },
]